import React, { useCallback, useEffect, useState } from "react";

import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Button } from "../../../Form";
import Modal from "../../../Generic/Modal";
import useStyles from "./styles";

type UploadContentModalProps = {
  isOpen: boolean;
  onClickTryAgain: () => void;
  showWarning?: boolean;
};

export const UploadContentModal = ({
  isOpen,
  onClickTryAgain,
  showWarning = false,
}: UploadContentModalProps) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();

  const [tryAgainButtonIsDisable, setTryAgainButtonIsDisable] = useState<boolean>(true);

  const debounce = useCallback(() => {
    if (!isOpen) return setTimeout(() => {});

    return setTimeout(() => {
      setTryAgainButtonIsDisable(false);
    }, 5000);
  }, [isOpen]);

  useEffect(() => {
    debounce();

    return () => clearTimeout(debounce());
  }, [isOpen, debounce]);

  return (
    <Modal open={isOpen} className={classes.modalSize}>
      <div className={classes.container}>
        <CircularProgress className={classes.loading} />

        <span className={classes.title}>{translate("uploadingYourContent")}</span>

        {showWarning && (
          <span className={classes.warningMessage}>{translate("thisMightTakeAWhile")}</span>
        )}

        <div className={classes.information}>
          {translate("weReSecurelyLoadingYourDataIntoShipeeziSCertifiedFramework")}
        </div>

        <div className={classes.information}>
          <span>{translate("ifThisIsTakingTooMuchLonger")}</span>

          <Button
            className={classes.tryAgainButton}
            onClick={() => {
              setTryAgainButtonIsDisable(true);
              onClickTryAgain();
              debounce();
            }}
            disabled={tryAgainButtonIsDisable}
          >
            {translate("tryAgain")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
